import { Stack } from "@fluentui/react";
import {
  stackTokens,
  styles,
} from "../ExperimentDetailsForm/experimentDetailsForm.styles";
import { ExperimentFormContext } from "../../../Hooks/UseExperimentForm";
import AdvancedFilters from "../ExperimentDetailsForm/AdvancedFilters";

interface AdvancedFiltersFormProps {
  /**
   * Form context containing form state, handlers, and validation logic
   */
  experimentFormContext: ExperimentFormContext;
  /**
   * Validation errors keyed by field name
   */
  errors?: Record<string, string[]>;
  /**
   * When true, forms are editable. When false, forms are read-only.
   */
  isEditMode?: boolean;
}

/**
 * Form component for configuring advanced filtering options for experiments.
 * Handles tenant filters, extension version filters, and environment filters
 * to control experiment audience targeting.
 *
 * Filter Types:
 * - Tenant Filters: Target specific tenants with operator-based logic
 * - Extension Version Filters: Target specific extension versions
 * - Environment Filters: Target specific deployment environments
 */
const AdvancedFiltersForm: React.FC<AdvancedFiltersFormProps> = ({
  experimentFormContext,
  isEditMode = false,
  errors = {},
}) => {
  const {
    formState: { environmentFilters = {} },
    tenantFiltersOperator,
    tenantFiltersList,
    handleTenantFiltersOperatorChange,
    handleTenantFiltersListChange,
    extensionVersionFilters,
    handleExtensionVersionFiltersOperatorChange,
    handleExtensionVersionFiltersVersionChange,
    handleEnvironmentFiltersChange,
  } = experimentFormContext;

  return (
    <Stack className={styles.formContainer} tokens={stackTokens}>
      <AdvancedFilters
        tenantFiltersOperator={tenantFiltersOperator}
        tenantFiltersList={tenantFiltersList}
        onTenantFiltersOperatorChange={handleTenantFiltersOperatorChange}
        onTenantFiltersListChange={handleTenantFiltersListChange}
        extensionVersionFiltersOperator={extensionVersionFilters.operator}
        extensionVersionFiltersVersion={extensionVersionFilters.version}
        onExtensionVersionFiltersOperatorChange={
          handleExtensionVersionFiltersOperatorChange
        }
        onExtensionVersionFiltersVersionChange={
          handleExtensionVersionFiltersVersionChange
        }
        environmentFilters={environmentFilters}
        onEnvironmentFiltersChange={handleEnvironmentFiltersChange}
        isEdit={isEditMode}
        errors={errors}
      />
    </Stack>
  );
};

export default AdvancedFiltersForm;
